module.exports = __webpack_public_path__ + "static/media/pl.d3ef7ce0.svg";